import React from 'react'
import EyefinitySectionFields from '../EyefinitySectionFields'

export default function Frame(props) {
  return <EyefinitySectionFields {...props} sectionName="frame" title="Frame" />
}
